import React, { useEffect, useState } from "react";
import { useMediaQuery } from "react-responsive";

type ComponentGetter = () => Promise<React.ReactNode>;

type Props = {
  mobile: ComponentGetter;
  desktop: ComponentGetter;
  children: (component: React.ReactNode) => React.ReactElement;
};

const Responsive = ({ mobile, desktop, children }: Props) => {
  const [component, setComponent] = useState<null | React.ReactNode>(null);
  const isDesktop = useMediaQuery({
    query: "(min-width: 1224px)",
  });

  async function loadComponent(
    desktop: ComponentGetter,
    mobile: ComponentGetter,
    isDesktop: boolean
  ) {
    const getComponent = isDesktop ? desktop : mobile;
    const currentComponent = await getComponent();
    setComponent(currentComponent);
  }

  useEffect(() => {
    loadComponent(desktop, mobile, isDesktop);
  }, [desktop, mobile, isDesktop]);

  // @ts-ignore
  return children(component ? component!.default : () => null);
};

export default Responsive;
